module.exports = __webpack_public_path__ + "media/images/product_owners/fbi_90-7f63bb9fab6d1e7c7d544c5c367b0cfe.png";